<div class="alert alert-danger" *ngIf="error$ | async as errorMessage">
  <p>{{ errorMessage }}</p>
</div>
